export default __webpack_public_path__ + "static/popup-reports-50bf157dcd08c7bc36ca7f735d625b5b.png";